import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * Smooth scrolling, desktop only — same configuration as the Ortexo site.
 * Skipped on touch/small screens (native momentum is better there) and for
 * anyone who asked for reduced motion.
 *
 * The instance is published on window.__lenis so anchor navigation can hand
 * off to it instead of fighting it with scrollIntoView.
 */
const useLenis = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (window.innerWidth < 768 || prefersReduced) return undefined;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      touchMultiplier: 2,
      infinite: false,
    });

    window.__lenis = lenis;

    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);
};

export default useLenis;
